import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

const WHATSAPP_NUMBER = '447418609483';
const PREFILLED_MESSAGE = "Hi Flexdesk UK, I'd like to know more about your administrative services.";

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
      // Auto-show tooltip briefly to draw attention
      setShowTooltip(true);
      const hide = setTimeout(() => setShowTooltip(false), 4000);
      return () => clearTimeout(hide);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ type: 'spring', stiffness: 260, damping: 20 }}
          className="fixed bottom-6 right-6 z-50 flex items-center gap-3"
        >
          {/* Tooltip / label */}
          <AnimatePresence>
            {showTooltip && (
              <motion.div
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                className="hidden sm:flex items-center gap-2 bg-white text-slate-800 px-4 py-2.5 rounded-2xl shadow-xl border border-slate-100"
              >
                <span className="text-sm font-medium">Chat with us on WhatsApp</span>
                <button
                  onClick={(e) => { e.stopPropagation(); setShowTooltip(false); }}
                  aria-label="Dismiss"
                  className="text-slate-400 hover:text-slate-600"
                  data-testid="whatsapp-tooltip-close"
                >
                  <X className="w-4 h-4" />
                </button>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Button */}
          <button
            onClick={handleClick}
            onMouseEnter={() => setShowTooltip(true)}
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-button"
            className="relative w-16 h-16 bg-[#25D366] hover:bg-[#20bd5a] rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110 group"
          >
            {/* Pulsing ring */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <svg
              viewBox="0 0 32 32"
              className="w-8 h-8 relative z-10 fill-white"
              aria-hidden="true"
            >
              <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.048 9.376L1.05 31.3l6.13-1.96A15.9 15.9 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.31 22.596c-.386 1.09-1.92 1.994-3.142 2.258-.836.178-1.928.32-5.604-1.204-4.7-1.948-7.726-6.724-7.962-7.034-.226-.31-1.9-2.53-1.9-4.826s1.166-3.422 1.58-3.89c.34-.386.9-.562 1.436-.562.174 0 .33.008.472.016.414.018.622.042.896.696.34.816 1.16 2.83 1.258 3.036.1.206.168.448.03.758-.128.31-.24.448-.446.696-.206.248-.402.44-.608.71-.188.24-.4.5-.172.896.228.386 1.014 1.672 2.178 2.71 1.5 1.34 2.74 1.756 3.16 1.932.31.128.68.098.906-.15.286-.31.638-.826.996-1.334.254-.362.574-.408.912-.28.344.12 2.174 1.024 2.548 1.21.374.186.62.276.712.43.09.156.09.9-.296 1.99z"/>
            </svg>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppButton;
